export default "__VITE_ASSET__DwkgsSXh__"